import { Caract_solicitud } from '../../../models/caract_solicitud.model';
import { Component } from "@angular/core";
import { FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import * as moment from 'moment'
import { MatDatepickerInputEvent } from '@angular/material/datepicker';

@Component({
    selector: "page-caract_solicitud",
    templateUrl: "./caract_solicitud.component.html",
    styleUrls: ["./caract_solicitud.component.css"],
    providers: [FormService]
})

export class Caract_solicitudComponent {
      public rows = [];
      public actualRow;
      public caract_solicitud: Caract_solicitud;
      public form;
      public matcher = new FormService();
      public formNumber;
      public encontrado;

    public fecha;
    public maxDate;
    constructor() {

        this.maxDate = moment().toDate()

        this.form = new FormGroup({
            num_reso_perm: new FormControl(''),
            tipo_garantia: new FormControl(''),
            fecha_reso_perm: new FormControl({ value: '', disabled: true })
        })

        if (!JSON.parse(localStorage.getItem("caract_solicitud"))) {
            localStorage.setItem("caract_solicitud", JSON.stringify(this.rows));
        } else {
            this.rows = JSON.parse(localStorage.getItem("caract_solicitud"));
            this.form.controls['num_reso_perm'].setValue(this.rows[0] ? this.rows[0].num_reso_perm : '');
            this.form.controls['fecha_reso_perm'].setValue(this.rows[0] ? this.rows[0].fecha_reso_perm : null);
            this.form.controls['tipo_garantia'].setValue(this.rows[0] ? this.rows[0].tipo_garantia : '');
        }
         this.caract_solicitud = {num_reso_perm:'',fecha_reso_perm:null, tipo_garantia:'' };

    }

    add_caract_solicitud(event?: MatDatepickerInputEvent<Date>, type?) {
        if (event) {

            this.fecha = moment(event.value).format('DD/MM/YYYY')
        }
        else {
            var temp = JSON.parse(localStorage.getItem("caract_solicitud"))
            if (temp[0]) {
                this.fecha = temp[0].fecha_reso_perm;

            }
        }

        localStorage.setItem("caract_solicitud", JSON.stringify([]));
        this.actualRow = localStorage.getItem("caract_solicitud");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            num_reso_perm: this.form.value.num_reso_perm,
            tipo_garantia: this.form.value.tipo_garantia,
            fecha_reso_perm: this.fecha
        })
        localStorage.setItem("caract_solicitud", JSON.stringify(this.rows));

    }

    delete_caract_solicitud(id) {
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("caract_solicitud", JSON.stringify(this.rows));
            }
        }
    }

}